export const templateImagesPaths =[
    //this object contains the paths of the static template images that will be used to display template images in the Home page.
    {
        name:'Template 1',
        imageSource:require('./images/temp1.jpg'),
    },
    {
        name:'Template 2',
        imageSource:require('./images/temp2.jpg'),
    },
    {
        name:'Template 3',
        imageSource:require('./images/temp3.jpg'),
    },
    {
        name:'Template 4',
        imageSource:require('./images/temp4.jpg'),
    }
]

export const stateNames =['Andhra Pradesh',"Andaman and Nicobar Islands","Arunachal Pradesh","Assam","Bihar","Chandigarh"
,"Chhattisgarh" ,"Dadar and Nagar Haveli","Daman and Diu","Delhi","Lakshadweep","Puducherry","Goa","Gujarat","Haryana"
,"Himachal Pradesh","Jammu and Kashmir","Jharkhand","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur","Meghalaya"
,"Mizoram","Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh","Uttarakhand","West Bengal"
]